import { EBehavior, NestedCheckboxGroupsWithSearchDesktop } from '@cian/nested-checkbox-groups';
import { useToggleState } from '@cian/react-utils';
import { Outside } from '@cian/ui-kit';
import cn from 'classnames';
import * as React from 'react';
import { HandleNestedCheckboxClick } from '../FilterBusinessAppointments/types';
import * as styles from './FilterNestedCheckboxGroupsWithSearchDropdown.css';
import { SelectButton } from './internal/SelectButton';
import { IFilterNestedCheckboxGroupsWithSearchDropdownProps } from './types';

export const FilterNestedCheckboxGroupsWithSearchDropdown =
  React.memo<IFilterNestedCheckboxGroupsWithSearchDropdownProps>(function FilterDropdown(props) {
    const {
      checkboxGroups,
      checkboxValues,
      onNestedCheckboxClick,
      onTitleCheckboxClick,
      label,
      isPlaceholderLabel,
      onBlur,
    } = props;

    const { state: isDropdownVisible, toggle: toggleVisibility } = useToggleState();

    const handleFilterButtonClick = React.useCallback<VoidFunction>(() => {
      if (checkboxGroups.length) {
        toggleVisibility();
      }
    }, [checkboxGroups.length, toggleVisibility]);

    const handleNestedCheckboxClick = React.useCallback<HandleNestedCheckboxClick>(
      value => {
        onNestedCheckboxClick(value);
        toggleVisibility();
      },
      [onNestedCheckboxClick, toggleVisibility],
    );

    const handleOutside = React.useCallback(() => {
      toggleVisibility();
      onBlur();
    }, [onBlur, toggleVisibility]);

    /**
     * Данный костылек лечит следующую проблему:
     * если мы открывает дропдаун и кликаем на последний элемент,
     * то страница проскальзывает вниз.
     * Возможно, причина в том, что глобальный скролл запонимает сдвиг внутреннего скролла в дропдауне
     */
    const scrollPosition = React.useRef(window.scrollY);
    // istanbul ignore next
    React.useEffect(() => {
      if (isDropdownVisible) {
        scrollPosition.current = window.scrollY;
      } else {
        window.scrollTo({ top: scrollPosition.current });
      }
    }, [isDropdownVisible]);

    return (
      <Outside onOutside={handleOutside} active={isDropdownVisible}>
        <div className={styles['container']}>
          <SelectButton
            onClick={handleFilterButtonClick}
            label={label}
            isOpened={isDropdownVisible}
            isPlaceholderLabel={isPlaceholderLabel}
          />
          <div className={cn(styles['dropdown-wrapper'], { [styles['hidden']]: !isDropdownVisible })}>
            <NestedCheckboxGroupsWithSearchDesktop
              behavior={EBehavior.Single}
              classNameNestedCheckboxGroups={styles['nested-checkbox-groups']}
              groups={checkboxGroups}
              values={checkboxValues}
              onNestedCheckboxClick={handleNestedCheckboxClick}
              onTitleCheckboxClick={onTitleCheckboxClick}
            />
          </div>
        </div>
      </Outside>
    );
  });
